import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { referralClient } from "@core/clients";
import { InviteVariables } from "@core/types";

const useInviteMutation = (options?: UseMutationOptions<any, any, InviteVariables>) =>
  useMutation(
    ["invite"],
    async (variables) => {
      const data = await referralClient.invite(variables);
      return data;
    },
    options
  );

export default useInviteMutation;
